import { useEffect, useState } from "react";
import { useOAS } from "../../../context/SuperAdmin/OASContexts/OASContext";

function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value);
}

function getTpTipoId(tiposObjetivo: any[]): string {
  const tpTipo = tiposObjetivo.find((t) => t?.codigo === "TP");
  return tpTipo?.id_tipo_objetivo ? String(tpTipo.id_tipo_objetivo) : "";
}

function includesTipoObjetivo(orgTipos: unknown, tpId: string): boolean {
  if (!tpId) return false;
  if (!isStringArray(orgTipos)) return false;

  return orgTipos.map(String).includes(tpId);
}

export function useAllowedTP() {
  const { organizacion, tiposObjetivo, isLoadingOthers } = useOAS();
  const [allowedTP, setAllowedTP] = useState(false);

  const isLoadingTPInfo = Boolean(isLoadingOthers && !organizacion);

  useEffect(() => {
    const orgTipoObjetivo = organizacion?.tipo_objetivo;
    const tpId = getTpTipoId(tiposObjetivo ?? []);

    setAllowedTP(includesTipoObjetivo(orgTipoObjetivo, tpId));
  }, [organizacion, tiposObjetivo]);

  return { allowedTP, isLoadingTPInfo };
}
